export enum FetchDataStatus {
    Fetching,
    NotFetched,
    Success,
    Error,
    NotFound,
    Unauthorized,
}
